// The store's size charts, transcribed from the pictures in the client's "SIZE CHARTS" folder on
// 2026-09-22. Garment measurements, laid flat, in inches; the page converts to centimetres.
// A chart is a list of size families; a family is a list of sizes and the rows measured for them.
// A text row (which numbered sizes a youth size fits) is a list of strings.
window.SBG_SIZE_CHARTS = Object.freeze({
  'kids-tee': {
    title: 'Kids tees',
    families: [
      { name: 'Baby', sizes: ['3/6M', '6/12M', '12/18M', '18/24M'], rows: { 'Body length': [11.25, 12.25, 13.25, 14.25], 'Chest, laid flat': [10, 10.5, 11, 11.5] } },
      { name: 'Toddler', sizes: ['2T', '3T', '4T', '5T'], rows: { 'Body length': [15.5, 16.5, 17.5, 18.5], 'Chest, laid flat': [12, 13, 14, 15] } },
      { name: 'Youth', sizes: ['S', 'M', 'L', 'XL'], rows: { 'Body length': [20.875, 22.125, 23.375, 24.375], 'Chest, laid flat': [15.25, 16.25, 17.25, 18.25], 'Fits sizes': ['6 to 8', '10 to 12', '14 to 16', '18 to 20'] }, tolerance: 0.75 },
    ],
  },
  'kids-sweatshirt': {
    title: 'Kids sweatshirts',
    families: [
      { name: 'Baby', sizes: ['3/6M', '6/12M', '12/18M', '18/24M'], rows: { 'Body length': [11.25, 12.25, 13.25, 14.25], 'Chest, laid flat': [10, 10.5, 11, 11.5] } },
      { name: 'Toddler', sizes: ['2T', '3T', '4T', '5/6', '7'], rows: { 'Body length': [15, 16, 17, 18, 19], 'Chest, laid flat': [13, 13.5, 14, 15, 15.5], 'Sleeve length': [11.75, 12.25, 13.75, 16, 16.75] } },
      { name: 'Youth', sizes: ['XS', 'S', 'M', 'L', 'XL'], rows: { 'Body length': [19.75, 21.25, 22.5, 24, 25.5], 'Chest, laid flat': [16, 17, 18, 19, 20], 'Sleeve, from centre back': [23.5, 26.5, 27.75, 30.25, 33], 'Fits sizes': ['4', '6 to 8', '10 to 12', '14 to 16', '18 to 20'] }, tolerance: 1 },
    ],
  },
  'adult-tee': {
    title: 'Adult tees',
    families: [
      { name: 'Adult', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'], rows: { 'Body length': [26.6, 28, 29.4, 30.75, 31.6, 32.5, 33.5], 'Chest, laid flat': [18.25, 20.25, 22, 24, 26, 27.75, 29.75] }, tolerance: 1.25 },
    ],
  },
  'adult-sweatshirt': {
    title: 'Adult sweatshirts',
    families: [
      { name: 'Adult', sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'], rows: { 'Body length': [26, 27, 28, 29, 30, 31, 32, 33, 34], 'Chest, laid flat': [18, 20, 22, 24, 26, 28, 30, 32, 34], 'Sleeve, from centre back': [32.5, 33.5, 34.5, 35.5, 36.5, 37.5, 38.5, 39.5, 40.5] }, tolerance: 1 },
    ],
  },
  onesie: {
    title: 'Onesies',
    families: [
      { name: 'Newborn', sizes: ['NB'], rows: { 'Body length': [10.75], 'Chest, laid flat': [7.5], 'Sleeve length': [2.5] }, tolerance: 1 },
    ],
  },
});